import React, { useState } from "react";
import img2 from "../assets/hol2.jpg";
import img1 from "../assets/hol3.jpg";
import c1 from "../assets/hol5.jpg";
import img3 from "../assets/aholy.jpg";
import SectionHeadline from "./SectionHeadline";

const About = () => {
  const [currentImage, setCurrentImage] = useState(img3);

  const thumbnails = [img1, img2, c1];

  return (
    <section className=" flex flex-col md:gap-16 gap-10 justify-center items-center">
      <div className=" md:w-10/12">
        <SectionHeadline
          title=" About The Holy Vision Campus "
          backgroundImage={img2}
        />
      </div>

      <div className=" md:px-0 px-4 w-full md:w-10/12 ">
        <div className=" md:flex justify-between">
          <div className=" flex-1 lg:col-span-3 lg:row-end-1">
            <div className="lg:flex lg:items-start">
              <div className="lg:order-2 lg:ml-5">
                <div
                  data-aos="zoom-in"
                  data-aos-duration="1000"
                  className="max-w-xl overflow-hidden rounded-lg"
                >
                  <img
                    className=" w-96 h-96 max-w-full object-cover"
                    src={currentImage}
                    alt=""
                  />
                </div>
              </div>

              <div className="mt-5 md:mt-0 w-full lg:order-1 lg:w-32 lg:flex-shrink-0">
                <div
                  data-aos="fade-up"
                  data-aos-duration="1000"
                  className="flex flex-row items-start gap-4 md:gap-0 lg:flex-col"
                >
                  {thumbnails.map((src, index) => (
                    <button
                      key={index}
                      type="button"
                      className={`flex-0 aspect-square mb-3  h-20 overflow-hidden rounded-lg border-2 ${
                        currentImage === src
                          ? "border-gray-900"
                          : "border-transparent"
                      } text-center`}
                      onClick={() => setCurrentImage(src)}
                    >
                      <img
                        className="h-full w-full object-cover"
                        src={src}
                        alt=""
                      />
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className=" md:mt-0 mt-6 md:flex-1 flex flex-col gap-4 ">
            <h1 className=" text-xl font-serif"> Introduction</h1>
            <p>
              The establishment of Holy Vision Technical Campus has been
              inspired by twin objectives of producing the middle level health
              professionals and preparing them for employment on completion of
              their education and training. The graduates of this campus will be
              able to provide quality health care to mainly rural population in
              all preventive, promotive, curative, drug management and
              rehabilitative aspects. Among these three programs PCL in Nursing,
              General Medicine and Diploma in Pharmacy, Nursing program was
              initiated in 2002 followed by General Medicine program in 2003 and
              Diploma in Pharmacy program in 2004. Maximum number of students
              has completed their 3 years course with flying colours by
              obtaining distinction and first division marks.
            </p>
            <h1 className=" text-xl font-serif"> Academic Program</h1>
            <p>
              The 3 years academic program of Proficiency Certificate Level in
              Nursing (Staff Nurse), General Medicine (Health Assistant) and
              Diploma in Pharmacy are offered and the curriculum prescribed by
              CTEVT, recognized by Tribhuvan University and approved by Nepal
              Nursing Council, Nepal Health Proffessional Council and Nepal
              Pharmacy Council.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
